<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppStore } from '@/stores/app';
import { RouteEnum } from '@/constants/enums/RouteEnum';

const props = defineProps<{ logoColor?: 'dark' | 'light' }>(); // Header Logo 日夜版
const appStore = useAppStore();
const router = useRouter();
const route = useRoute();
const formChoose = defineModel('formChoose');
const isJuniorLoginPage = computed(() => route.name === 'loginJunior');

const logoFileName = computed(() => {
  console.log('===appStore.isMobile', appStore.isMobile)
  if (route.name === RouteEnum.LoginJunior) {
    return appStore.isMobile ? 'FUNDAY-Junior-LOGO.svg' : 'FUNDAY-Junior-lg-LOGO.svg';
  }

  if (props?.logoColor == 'dark') {
    return appStore.isMobile ? 'FUNDAY-lg-dark.svg' : 'FUNDAYLOGO-dark.svg';
  }

  // 默認為日版 props?.theme == 'light'
  return appStore.isMobile ? 'FUNDAY-lg.svg' : 'FUNDAYLOGO.svg';
});
</script>

<template>
  <header class="login-header">
    <div class="login-header-wrapper pageContainer">
      <div class="logo">
        <img
          :class="{
            'junior-login-Logo-mobile': isJuniorLoginPage && appStore.isMobile,
            'junior-login-Logo': isJuniorLoginPage && !appStore.isMobile
          }"
          loading="lazy"
          fetchpriority="high"
          decoding="async"
          :src="`/images/logo/${logoFileName}`"
          alt="FUNDAY"
        />
      </div>

      <ul class="options">
        <li v-if="!appStore.isLanding" class="login-btn" :class="props?.logoColor == 'light' ? 'light-login-btn' : ''" @click="formChoose = 'LoginForm'">登入</li>
        <li v-if="appStore.isLanding" class="return-btn" :class="props?.logoColor == 'light' ? 'light-login-btn' : ''" @click="router.back()">返回學習 ></li>
      </ul>
    </div>
  </header>
  <!-- </div> -->
</template>

<style scoped lang="scss">
.light-login-btn {
  background-color: white !important;
  color: black !important;
}
.login-header {
  position: absolute;
  top: 0;
  left: 0;
  display: block;

  width: 100%;
  z-index: 2;
  padding-block: 16px;

  background-color: transparent;

  &-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: block;
      margin-inline: 0 auto;
      height: 100%;
      max-width: 206px;
      width: 10.7%;

      // img {
      //     @include wh;
      // }

      .junior-login-Logo {
        padding-top: 20px; // Logo 陰影會造成視覺上沒有置中
      }
    }
  }
}
.options {
  // flex: 1;
  display: flex;
  align-items: center;
  justify-content: end;
  color: white;
  gap: 16px;
  li {
    cursor: pointer;
    &.login-btn {
      width: 84px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
      background: #3a3a3a;
      color: #fff;
      font-size: 18px;

      @include media-breakpoint-down(md) {
        width: 60px;
        height: 32px;
        font-size: 14px;
      }
    }
    &.return-btn {
      border-radius: 100px;
      background: #3a3a3a;
      color: #fff;
      padding: 12px 24px;
      font-size: 18px;
      line-height: 24px;
    }
    &.join-btn {
      width: 120px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 16px;
      border-radius: 100px;
      background-color: #f74768;
      font-size: 18px;
    }
  }
}

@media (max-width: '390px') {
  .login-header {
    &-wrapper {
      .logo {
        .junior-login-Logo {
          width: 184px;
          aspect-ratio: 55 / 12;
        }
      }
    }
  }
}
</style>
